"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConsentForm = exports.getCheckServiceAvailability = exports.getAutoSuggestionHomecareSearch = void 0;
exports.getMultipleServiceCategoryDetail = getMultipleServiceCategoryDetail;
exports.getServiceCategory = getServiceCategory;
exports.getServiceCategoryCarousel = getServiceCategoryCarousel;
exports.getServiceCategoryDetail = getServiceCategoryDetail;
exports.getServicePrice = getServicePrice;
exports.getServicesPackages = void 0;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getServiceCategory(tokenData) {
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_SERVICE_CATEGORIES;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getServiceCategoryDetail(HISId, queryParam, tokenData) {
  const queryString = (0, _utils.getQuery)(queryParam);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_SERVICE_CATEGORIES_DETAIL + '/' + HISId + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
const getServicesPackages = (params, tokenData) => {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_SERVICES_PACKAGES + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getServicesPackages = getServicesPackages;
function getMultipleServiceCategoryDetail(requestParams, tokenData) {
  const query = (0, _utils.getQuery)(requestParams);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_SERVICE_CATEGORIES_DETAIL + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
const getConsentForm = (params, tokenData) => {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.HOMECARE_CONSENT_FORM + params;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getConsentForm = getConsentForm;
function getServiceCategoryCarousel(params, tokenData) {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.HOMECARE_CAROUSEL_API + _ApiConst.HOMECARE_SERVICE_CATEGORIES_CAROUSEL + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
const getCheckServiceAvailability = (query, tokenData) => {
  const queryString = (0, _utils.getQuery)(query);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_LOCATION_SERVICE + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getCheckServiceAvailability = getCheckServiceAvailability;
const getAutoSuggestionHomecareSearch = (params, tokenData) => {
  const query = (0, _utils.getQuery)(params);
  const apiEndPoint = _ApiConst.DYNAMIC_SEARCH_BASE_URL + _ApiConst.HOMECARE_AUTOSUGGEST_SEARCH + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.getAutoSuggestionHomecareSearch = getAutoSuggestionHomecareSearch;
function getServicePrice(queryParam, tokenData) {
  const queryString = (0, _utils.getQuery)(queryParam);
  const apiEndPoint = _ApiConst.HOMECARE_SEARCH_API + _ApiConst.HOMECARE_SERVICE_PRICE_URL + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}